/* Copyright (c) Librestream Technologies. All rights reserved. */
/* eslint-disable */ 

import {utf8ToString, stringToUtf8} from 'SERVICES/lsexif/exifutils';
import logger from 'SERVICES/lsexif/logger';

import { LS_DATASTREAM_PARTICIPANTID } from '../../utils/constants/DatastreamConstant';

export const SIZEOF_UINT32 = 4;
export const SIZEOF_UINT16 = 2;
export const SIZEOF_DOUBLE = 8;

const TELESTRATION_LOG_TAG = "TELE";
const TELESTRATION_LOG_EVENT_TAG = "TELE Event";
const TELESTRATION_LOG_EN = false;

export const TelePointConstants = {  
  TELESTRATION_MAX_TELEPOINTS : 50,

  TELESTRATION_EVENT_TYPE_DRAW : 0,
  TELESTRATION_EVENT_TYPE_REFRESH : 1,
  TELESTRATION_EVENT_TYPE_POINTER : 2,
  TELESTRATION_EVENT_TYPE_STREAM_START_COMPLETE : 3,
  TELESTRATION_EVENT_TYPE_CLEAR : 4,
  TELESTRATION_EVENT_TYPE_REMOVE : 5,

  TELESTRATION_KIND_LIVE_VIDEO : 0,
  TELESTRATION_KIND_STILL_IMAGE : 1,

  TELESTRATION_SET_NONE : 0x00,
  TELESTRATION_SET_LIVE_LOCAL : 0x01,
  TELESTRATION_SET_LIVE_REMOTE : 0x02,
  TELESTRATION_SET_LIVE_BOTH : 0x03,
  TELESTRATION_SET_RECORDED_LOCAL : 0x04,
  TELESTRATION_SET_RECORDED_REMOTE : 0x08,
  TELESTRATION_SET_RECORDED_BOTH : 0x0C,
  TELESTRATION_SET_ALL : 0x3F,
  TELESTRATION_SET_LIVE : 0x10,
  TELESTRATION_SET_RECORDED : 0x20,

  TELESTRATION_TYPE_EXTENDED : 0x0001,
  TELESTRATION_TYPE_TELESTRATION : 0x0002,
  TELESTRATION_TYPE_CLEAR : 0x0004,
  TELESTRATION_TYPE_PENUP : 0x0008,
  TELESTRATION_TYPE_PENDOWN : 0x0010,
  TELESTRATION_TYPE_REMOTE : 0x0020,
  TELESTRATION_TYPE_STREAM_START_COMPLETE : 0x0040,
  TELESTRATION_TYPE_CLEAR_PIDS : 0x0080,
  TELESTRATION_TYPE_STILL_IMAGE_KIND : 0x0100,
  TELESTRATION_TYPE_REMOVE : 0x0200,
  TELESTRATION_TYPE_RECORDED : 0x4000,
  TELESTRATION_TYPE_DATAVALID : 0x8000,
  TELESTRATION_COLOUR_FLAG_REMOTE : 0x0001,

  TELESTRATION_ITEM_TYPE_NONE : -1,
  TELESTRATION_ITEM_TYPE_FREEHAND : 0,
  TELESTRATION_ITEM_TYPE_ELLIPSE : 1,
  TELESTRATION_ITEM_TYPE_LINE : 2,
  TELESTRATION_ITEM_TYPE_RECTANGLE : 3,
  TELESTRATION_ITEM_TYPE_ARROWLINE : 4,
  TELESTRATION_ITEM_TYPE_TEXT : 5,

  TELESTRATION_EXTRA_TEXT_INT16 : 3,

  TELESTRATION_RECORDED_LOCAL_ID : 0x00020000,
}

var TelestrationColourArray = 
[
    "#FF8080","#FFFF80","#80FF80","#00FF80","#80FFFF","#0080FF","#FF80C0","#FF80FF",
    "#FF0000","#FFFF00","#80FF00","#00FF40","#00FFFF","#0080C0","#8080C0","#FF00FF",
    "#804040","#FF8040","#00FF00","#008080","#004080","#8080FF","#800040","#FF0080",
    "#800000","#FF8000","#008000","#008040","#0000FF","#0000A0","#800080","#8000FF",
    "#400000","#804000","#004000","#004040","#000080","#000040","#400040","#400080",
    "#000000","#808000","#808040","#808080","#408080","#C0C0C0","#400040","#FFFFFF"
]

var RecordedTelestrationColoursDefault = [
      TelestrationColourArray[24],
      TelestrationColourArray[23],
      TelestrationColourArray[11],
      TelestrationColourArray[37],
      TelestrationColourArray[30],
      TelestrationColourArray[1],
      TelestrationColourArray[35],
      TelestrationColourArray[15],
      TelestrationColourArray[14],
      TelestrationColourArray[13],
      TelestrationColourArray[40],
      TelestrationColourArray[29],
      TelestrationColourArray[18],
      TelestrationColourArray[36],
      TelestrationColourArray[46],
      TelestrationColourArray[47],
      TelestrationColourArray[2],
      TelestrationColourArray[39],
      TelestrationColourArray[32],
      TelestrationColourArray[17],
      TelestrationColourArray[21],
      TelestrationColourArray[34],
      TelestrationColourArray[0],
      TelestrationColourArray[31],
      TelestrationColourArray[28],
      TelestrationColourArray[42],
      TelestrationColourArray[10],
      TelestrationColourArray[12],
      TelestrationColourArray[33],
      TelestrationColourArray[26],
      TelestrationColourArray[7],
      TelestrationColourArray[43],
      TelestrationColourArray[8],
      TelestrationColourArray[27],
      TelestrationColourArray[25],
      TelestrationColourArray[9],
      TelestrationColourArray[3],
      TelestrationColourArray[4],
      TelestrationColourArray[5],
      TelestrationColourArray[6],
      TelestrationColourArray[22],
      TelestrationColourArray[41],
      TelestrationColourArray[16],
      TelestrationColourArray[45],
      TelestrationColourArray[38],
      TelestrationColourArray[20],
      TelestrationColourArray[44],
      TelestrationColourArray[19]
]


///////////////////////////////////////////////////////////////////////////////
function TelePointData(_buffer, _offset) {
  if (_buffer != null && _offset != null) {

    var dv = new DataView(_buffer, _offset);

    var i = 0;
    this.type = dv.getUint16(i, true);
    i += SIZEOF_UINT16;

    this.num = dv.getUint16(i, true);
    i += SIZEOF_UINT16;

    this.pid = dv.getUint32(i, true);
    i += SIZEOF_UINT32;

    this.coords = [];  
    this.pids = [];
    this.extendedType = TelePointConstants.TELESTRATION_ITEM_TYPE_FREEHAND;

    if (this.type & TelePointConstants.TELESTRATION_TYPE_CLEAR_PIDS) {
      for (var j = 0; j < this.num; j++) {
        var pid = dv.getUint32(i, true);
        i += SIZEOF_UINT32;

        this.pids.push(pid);
      }
    }
    else {
      if (this.type & TelePointConstants.TELESTRATION_TYPE_EXTENDED) {
        this.extendedType = dv.getUint32(i, true);
        this.type |= TelePointConstants.TELESTRATION_TYPE_PENUP | TelePointConstants.TELESTRATION_TYPE_PENDOWN;
        i += SIZEOF_UINT32;        
        this.num--;
      }

      if (this.extendedType == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {        
        this.num = 2;
      }

      for (var j = 0; j < this.num; j++) {
        var x = dv.getInt16(i, true);
        i += SIZEOF_UINT16;

        var y = dv.getInt16(i, true);
        i += SIZEOF_UINT16;

        this.coords.push({x : x, y : y});
      }

      if (this.extendedType == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
        var fontSize = dv.getUint16(i, true) / 10.0;
        i += SIZEOF_UINT16;

        var fontId = dv.getUint16(i, true);
        i += SIZEOF_UINT16;

        var len = dv.getUint32(i, true);        
        i += SIZEOF_UINT32;

        var text = "";
        if (len > 0) {
          for (var l = 0; l < len; l++) {
            var c = dv.getUint16(i, true);
            text += String.fromCharCode(parseInt(c));
            i += SIZEOF_UINT16;
          }
        }
        
        this.text = {fontSize : fontSize, fontId : fontId, text : text};

        if ((len + TelePointConstants.TELESTRATION_EXTRA_TEXT_INT16) % 2 == 1) {
          i += SIZEOF_UINT16;
          len++;
        }
      }
    }
  }
  else {
    this.type = TelePointConstants.TELESTRATION_TYPE_TELESTRATION;
    this.coords = [];
    this.num = 1;
    this.pid = 0;

    this.pids = [];    
  }

  this.type |= TelePointConstants.TELESTRATION_TYPE_DATAVALID | TelePointConstants.TELESTRATION_TYPE_RECORDED;  
}

export function TelePointDataV3(_buffer) {
  if (_buffer != null) {
    var v3 = utf8ToString(new Uint8Array(_buffer), 12, _buffer.byteLength - 12 - 1);
    var index = 0;
    var lastCharacterIndex = v3.length;
    var parsedVal = JSON.parse(v3.slice(0, lastCharacterIndex));
    var clearPids = parsedVal.clearPids;
    this.colourArgb = parsedVal.colorArgb;
    var coords = parsedVal.coords;
    var fontid = parsedVal.fontid;
    var fontsize = parsedVal.fontsize;
    var isColorSet = parsedVal.isColorSet;
    this.num = parsedVal.num;
    this.pid = parsedVal.pid;
    var text = parsedVal.text;
    var thickness = parsedVal.thickness;
    this.type = parsedVal.type;

    this.extendedType = TelePointConstants.TELESTRATION_ITEM_TYPE_FREEHAND;

    this.pids = [];
    this.coords = [];

    if (this.type & TelePointConstants.TELESTRATION_TYPE_CLEAR_PIDS) {
      for (var j=0; j<clearPids.length; j++) {
      this.pids.push(clearPids[j]);
      }
    }
    else
    {
      if (this.type & TelePointConstants.TELESTRATION_TYPE_EXTENDED) {
        this.extendedType = parsedVal.telestrationExtendedType;
        this.type |= TelePointConstants.TELESTRATION_TYPE_PENUP | TelePointConstants.TELESTRATION_TYPE_PENDOWN;
      }

      for (var j=0; j < this.num; j++) {
        var x = coords[j].x;
        var y = coords[j].y;
        this.coords.push({x : x, y : y});
      }

      if (this.extendedType == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
        this.text = {fontSize : fontsize, fontId : fontid, text : text};
      }
    }
  }
  else {
      this.type = TelePointConstants.TELESTRATION_TYPE_TELESTRATION;
      this.coords = [];
      this.num = 1;
      this.pid = TelePointConstants.TELESTRATION_RECORDED_LOCAL_ID;
      this.pids = [];
    }
    this.type |= TelePointConstants.TELESTRATION_TYPE_DATAVALID | TelePointConstants.TELESTRATION_TYPE_RECORDED;
  }

///////////////////////////////////////////////////////////////////////////////

function TelestrationItem(_type) {
  this.coords = [];
  this.type = _type;
  this.c = null;
  this.tn = 0.0;
}

TelestrationItem.prototype.add = function(_coords) { 
  this.coords.push(_coords);
}

TelestrationItem.prototype.num = function() { 
  return this.coords.length;
}

TelestrationItem.prototype.clear = function() { 
  this.coords = [];
}

///////////////////////////////////////////////////////////////////////////////

function TelestrationSet(_pid, _strokeStyle) {
  this.pid = _pid;
  this.penDown = false;
  this.items = [];
  this.currItem = null;
  this.strokeStyle = _strokeStyle[0] == '#' ? _strokeStyle : argbToRGB(_strokeStyle);
  this.clr =  _strokeStyle;
  this.type = 0;
}

TelestrationSet.prototype.clear = function() {
  for (var i = 0; i < this.items.length; i++) {
    this.items[i].clear();
  }
  this.currItem = null;
  this.items = [];
}

TelestrationSet.prototype.remove = function(_item) {
  var removed = null;
  if (_item != null && _item.coords.length > 1) {
    for (var i = 0; i < this.items.length; i++) {
      // find the matching item
      // type, first and last coordinates must match
      if (this.items[i].type == _item.type &&
          this.items[i].coords.length > 0 &&
          this.items[i].coords[0].x == _item.coords[0].x &&
          this.items[i].coords[0].y == _item.coords[0].y &&
          this.items[i].coords[this.items[i].coords.length - 1].x == _item.coords[1].x &&
          this.items[i].coords[this.items[i].coords.length - 1].y == _item.coords[1].y) {

        removed = this.items[i];
        this.items.splice(i, 1);
        break;
      }
    }
  }
  return removed;
}

TelestrationSet.prototype.processMouseDown = function(_type, _coords) {
  this.penDown = true;
  this.currItem = new TelestrationItem(_type);
  if (_coords != null) {
    this.currItem.add(_coords);    
  }
  this.items.push(this.currItem);
}

TelestrationSet.prototype.processMouseUp = function(_type, _coords) {
  if (this.penDown && this.currItem != null && this.currItem.type == _type) {
    this.penDown = false;
    if (_coords != null) {
      if (_type == TelePointConstants.TELESTRATION_ITEM_TYPE_FREEHAND || this.currItem.coords.length == 1) {
        this.currItem.add(_coords); 
      }
      else {
        this.currItem.coords[this.currItem.coords.length - 1] = _coords;
      }
    }
  }
}

TelestrationSet.prototype.processMouseMove = function(_type, _coords) {
  var penDownAdded = false;
  if (!this.penDown) {
    // missed the pen down?
    this.processMouseDown(_type);
    penDownAdded = true;
  }

  if (this.penDown && _coords != null) {
    if (_type == TelePointConstants.TELESTRATION_ITEM_TYPE_FREEHAND || this.currItem.coords.length <= 1) {
      this.currItem.add(_coords);
    }
    else {
      this.currItem.coords[this.currItem.coords.length - 1] = _coords;
    }
  }
  return penDownAdded;
}

///////////////////////////////////////////////////////////////////////////////

export default function Telestration() {
  this.sets = [];
  this.kind = TelePointConstants.TELESTRATION_KIND_LIVE_VIDEO;
}

Telestration.prototype.getSet = function(_pid) {
  for (var i = 0; i < this.sets.length; i++) {
    if (this.sets[i].pid == _pid) {
      return this.sets[i];
    }
  }
  return null;
}

Telestration.prototype.getOrAllocateSet = function(_pid, _colour) {
  var set = this.getSet(_pid);
  if (set == null) {
    if (_colour == null) {
      throw("Telestration colour not set!");
    }
    set = new TelestrationSet(_pid, _colour);
    this.sets.push(set);
    logger.debug(TELESTRATION_LOG_EN, TELESTRATION_LOG_TAG, "Added set for pid " + _pid);
  }
  return set;
}

Telestration.prototype.clear = function(_pids) {
  if (_pids == null || _pids.length == 0) {
    // default to clear all
    _pids = [];
    _pids.push(LS_DATASTREAM_PARTICIPANTID.ALL_PARTICIPANTID);
  }

  var clearedSets = [];

  for (var i = 0; i < this.sets.length; i++) {
    if (_pids[0] == LS_DATASTREAM_PARTICIPANTID.ALL_PARTICIPANTID || _pids.includes(this.sets[i].pid)) {
      this.sets[i].clear();
      clearedSets.push(this.sets[i]);
      logger.debug(TELESTRATION_LOG_EN, TELESTRATION_LOG_TAG, "Cleared set for pid " + this.sets[i].pid);
    }
  }

  return clearedSets;
}

Telestration.prototype.remove = function(_pid, _item) {  
  var result = null;
  for (var i = 0; i < this.sets.length; i++) {
    if (_pid == this.sets[i].pid) {
      var removed = this.sets[i].remove(_item);
      if (removed != null) {
        logger.debug(TELESTRATION_LOG_EN, TELESTRATION_LOG_TAG, "Removed item for pid " + this.sets[i].pid);
        result = {set: this.sets[i], item: removed};
      }
      break;
    }
  }
  return result;
}

Telestration.parseTeleBlobR4 = function(_buffer, _offset, _length, _colourCallback) {
    var t = new Telestration();

    var dv = new DataView(_buffer, _offset, _length);    
    var i = 0;    

    // read the version       
    var version = dv.getUint32(i, true);
    i += SIZEOF_UINT32;    
    while (i < _length) {
        if (version == 2) {        
            i += t.parseTeleBlobV2(_buffer, _offset + i, _length - i, _colourCallback);
        }
        else {
            logger.error(true, TELESTRATION_LOG_TAG, "Unsupported telestration blob version " + version);
            break;
        }
    }
    return t;
}


Telestration.parseTeleBlobR3 = function(v3) {
    var t = new Telestration();
    t.parseTeleBlobV3(v3);
    return t;
}


export function argbToRGB(color) {
  color >>>= 0;
  var b = color & 0xFF,
      g = (color & 0xFF00) >>> 8,
      r = (color & 0xFF0000) >>> 16,
      a = 255;
  return "rgba(" + [r, g, b, a].join(",") + ")";
}

export function hexToArgb(hex) {
  var argb;
  if (hex[0] === '#') {
    var rgb = hexToRgb(hex);
    var a = 255;

    argb = ((a & 0x0ff) << 24 | (rgb.r & 0x0ff) << 16) | ((rgb.g & 0x0ff) << 8) | (rgb.b & 0x0ff);
  } else {
    var xx = hex.replace("rgba(", "").replace(")", "");
    var rgb = xx.split(",");
    argb = ((rgb[3] & 0x0ff) << 24 | (rgb[0] & 0x0ff) << 16) | ((rgb[1] & 0x0ff) << 8) | (rgb[2] & 0x0ff);
  }
  return argb;
}


Telestration.hexToArgb = function (hex) {
  var argb;
  if (hex[0] == '#') {
    var rgb = hexToRgb(hex);
    var a = 255;

    argb = ((a&0x0ff)<<24|(rgb.r&0x0ff)<<16)|((rgb.g&0x0ff)<<8)|(rgb.b&0x0ff);
  } else {
    var xx = hex.replace("rgba(", "").replace(")", "");
    var rgb = xx.split(",");
    argb = ((rgb[3]&0x0ff)<<24|(rgb[0]&0x0ff)<<16)|((rgb[1]&0x0ff)<<8)|(rgb[2]&0x0ff);
  }
  return argb;
}


function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}


function mapTelestrationTypeToValue(type) {
  var xx = type.split(",")[0].split(".");
  if (xx.length > 0) type = xx[xx.length-1];

  switch(type) {
    case "TelestrationFreehand":
      return TelePointConstants.TELESTRATION_ITEM_TYPE_FREEHAND;
    case "TelestrationEllipse":
      return TelePointConstants.TELESTRATION_ITEM_TYPE_ELLIPSE;
    case "TelestrationRectangle":
      return TelePointConstants.TELESTRATION_ITEM_TYPE_RECTANGLE;
    case "TelestrationLine":
      return TelePointConstants.TELESTRATION_ITEM_TYPE_LINE;
    case "TelestrationText":
      return TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT;
    case "TelestrationArrowLine":
      return TelePointConstants.TELESTRATION_ITEM_TYPE_ARROWLINE;
    default:
      return TelePointConstants.TELESTRATION_ITEM_TYPE_NONE;
  }
}

Telestration.mapValueToTelestrationType = function (type) {
  switch(type) {
    case 0:
      return "TelestrationFreehand";
    case 1:
      return "TelestrationEllipse";
    case 2:
      return "TelestrationLine";
    case 3:
      return "TelestrationRectangle";
    case 4:
      return "TelestrationArrowLine";
    case 5:
      return "TelestrationText";
    default:
      return -1;
  }
}


Telestration.prototype.parseTeleBlobV3 = function(v3) {
  var parsedVal = JSON.parse(v3);

  for (var i=0; i<parsedVal.length; i++)
  {
    var items = parsedVal[i];
    var itemsColor = items.clr;
    var itemList = items.il;
    var pid = items.pid;
    var set = this.getOrAllocateSet(pid, itemsColor);
    for (var j=0; j<itemList.length; j++)
    {
      var item = itemList[j];
      var type = mapTelestrationTypeToValue(item.$type);
      var itemPoints = item.pc;

      for (var k = 0; k < itemPoints.length; k++) {
        if (type == TelePointConstants.TELESTRATION_ITEM_TYPE_FREEHAND ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_ELLIPSE ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_RECTANGLE ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_LINE ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_ARROWLINE ) {
          var x = itemPoints[k].x;
          var y = itemPoints[k].y;
          set.processMouseMove(type, {x : x, y : y});
        }
      }
      if (type == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
        set.currItem.fontId = item.fi;
        set.currItem.fontSize = item.fs;
        set.currItem.text = item.tx;
      }
      set.processMouseUp(type);
    }

  }
}


Telestration.prototype.parseTeleBlobV2 = function(_buffer, _offset, _length, _colourCallback) {
    var dv = new DataView(_buffer, _offset, _length);
    var i = 0;

    // read the pid
    var pid = dv.getUint32(i, true);
    i += SIZEOF_UINT32;    

    var set = this.getOrAllocateSet(pid, _colourCallback(pid));

    // read the number of items
    var numItems = dv.getUint32(i, true);
    i += SIZEOF_UINT32;    

    logger.debug(TELESTRATION_LOG_EN, TELESTRATION_LOG_TAG, "Pid " + pid + " Num items: " + numItems);

    for (var j = 0; j < numItems; j++) {
      var type = dv.getUint16(i, true);
      i += SIZEOF_UINT16;

      var numCoords = dv.getUint16(i, true);
      if (type == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
        numCoords = 2;
      }
      i += SIZEOF_UINT16;

      logger.debug(TELESTRATION_LOG_EN, TELESTRATION_LOG_TAG, "Found tele type: " + type + " numcoords: " + numCoords);

      for (var k = 0; k < numCoords; k++) {
        if (type == TelePointConstants.TELESTRATION_ITEM_TYPE_FREEHAND ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_ELLIPSE ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_RECTANGLE ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_LINE ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT ||
            type == TelePointConstants.TELESTRATION_ITEM_TYPE_ARROWLINE ) {
          var x = dv.getInt16(i, true);
          i += SIZEOF_UINT16;

          var y = dv.getInt16(i, true);
          i += SIZEOF_UINT16;
          set.processMouseMove(type, {x : x, y : y});
        }
        else {
          i += SIZEOF_UINT16 * 2;
        }
      }

      if (type == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
        set.currItem.fontSize = dv.getUint16(i, true) / 10.0;
        i += SIZEOF_UINT16;

        set.currItem.fontId = dv.getUint16(i, true);
        i += SIZEOF_UINT16;

        var len = dv.getUint16(i, true);        
        i += SIZEOF_UINT16;

        if (len > 0) {
          set.currItem.text = "";
          for (var l = 0; l < len; l++) {
            var c = dv.getUint16(i, true);
            set.currItem.text += String.fromCharCode(parseInt(c));
            i += SIZEOF_UINT16;
          }
        }
        
        if ((len + TelePointConstants.TELESTRATION_EXTRA_TEXT_INT16) % 2 == 1) {          
          i += SIZEOF_UINT16;
          len++;
        }        
      }

      set.processMouseUp(type);
    }    

    return i;
}

Telestration.prototype.setTeleBlobR4 = function(_buffer, _offset) {
    var dv = _buffer != null ? new DataView(_buffer, _offset) : null;
    var i = 0;    

    // set the version       
    if (dv != null) dv.setUint32(i, 2, true);
    i += SIZEOF_UINT32;

    // set the b2 blob

    this.sets.forEach(function(set) {
      if(set.il == undefined) {
        // set the pid
        if (dv != null) dv.setUint32(i, set.pid, true);
        i += SIZEOF_UINT32;

        // set the number of items
        if (dv != null) dv.setUint32(i, set.items.length, true);
        i += SIZEOF_UINT32;

        set.items.forEach(function(item) {
            // set the type
            if (dv != null) dv.setUint16(i, item.type, true);
            i += SIZEOF_UINT16;

            var numCoords = item.coords.length;
            if (item.type == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
              numCoords += (item.text.length + TelePointConstants.TELESTRATION_EXTRA_TEXT_INT16) / 2;
              if ((item.text.length + TelePointConstants.TELESTRATION_EXTRA_TEXT_INT16) % 2 == 1) {
                numCoords++;
              }
            }
            // set the number of coords
            if (dv != null) dv.setUint16(i, numCoords, true);
            i += SIZEOF_UINT16;

            item.coords.forEach(function(coord) {
              if (dv != null) dv.setUint16(i, coord.x, true);
              i += SIZEOF_UINT16;
              if (dv != null) dv.setUint16(i, coord.y, true);
              i += SIZEOF_UINT16;
            });

            if (item.type == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
              if (dv != null) dv.setUint16(i, item.fontSize * 10, true);
              i += SIZEOF_UINT16;
              if (dv != null) dv.setUint16(i, item.fontId, true);
              i += SIZEOF_UINT16;
              if (dv != null) dv.setUint16(i, item.text.length, true);
              i += SIZEOF_UINT16;

              for(var j = 0; j < item.text.length; j++) {
                if (dv != null) dv.setUint16(i, item.text.charCodeAt(j), true);
                i += SIZEOF_UINT16;
              }
              if ((item.text.length + TelePointConstants.TELESTRATION_EXTRA_TEXT_INT16) % 2 == 1) {
                // padding
                if (dv != null) dv.setUint16(i, 0, true);
                i += SIZEOF_UINT16;
              }
            }
        });
      }
    });
    return i;
}


///////////////////////////////////////////////////////////////////////////////

export function TelestrationManager() {
  this.telestration = new Telestration();
  this.telestrationVideo = this.telestration;
  this.onTelestrationEventCallback = null;
  this.nextTelestrationColour = 0;
  this.colourMap = {};
  this.defaultColour = null;

}

TelestrationManager.prototype.reset = function() { 
  this.telestration = new Telestration();
  this.telestrationVideo = this.telestration;
}

TelestrationManager.prototype.add = function(t) {  
  // this code ported from CoreInterface::OnNewTelePointData

  // if the new telestration is for still image but the telestration object kind is live video, ignore the telestration
  if ((t.type & TelePointConstants.TELESTRATION_TYPE_STREAM_START_COMPLETE) && ((t.type & TelePointConstants.TELESTRATION_TYPE_STILL_IMAGE_KIND) && this.telestration.kind == TelePointConstants.TELESTRATION_KIND_LIVE_VIDEO)) {
    // ignore...eventually it should get put into the Live Video telestration object
    return;
  }    

  // if the new telestration is for video AND current telestration object kind is still image
  // then flag it so we only add video telestration to the telestrationVideo object (not the current telestration object) without 
  // drawing. The telestration will be redrawn when picturesharing is exited.
  var isTeleVideoWhileInImageShare = ((t.type & TelePointConstants.TELESTRATION_TYPE_STREAM_START_COMPLETE) &&
                                      (t.type & TelePointConstants.TELESTRATION_TYPE_STILL_IMAGE_KIND) &&
                                      this.telestration.kind == TelePointConstants.StillImage);

  // we currently only handle recorded telestration
  if ((t.type & TelePointConstants.TELESTRATION_TYPE_DATAVALID) && (t.type & TelePointConstants.TELESTRATION_TYPE_TELESTRATION) && (t.type & TelePointConstants.TELESTRATION_TYPE_RECORDED)) {            
    if (t.type & TelePointConstants.TELESTRATION_TYPE_CLEAR_PIDS && !isTeleVideoWhileInImageShare) {
      // if the number of pids is 0...
      if (t.num == 0) {
        // clear all pids
        this.clearSet();
      }
      else {
        // clear those listed
        this.clearSet(t.pids);
      }
    }
    else if ((t.type & TelePointConstants.TELESTRATION_TYPE_STREAM_START_COMPLETE) && !isTeleVideoWhileInImageShare) {
      this.signalEvent({
        type: TelePointConstants.TELESTRATION_EVENT_TYPE_STREAM_START_COMPLETE,
        telestration: this.telestration
      });
    }
    else if ((t.type & TelePointConstants.TELESTRATION_TYPE_CLEAR) == TelePointConstants.TELESTRATION_TYPE_CLEAR) {
      var clearPids = [];
      clearPids.push(t.pid);                
      this.clearSet(clearPids); 
    }
    else if ((t.type & TelePointConstants.TELESTRATION_TYPE_EXTENDED) == TelePointConstants.TELESTRATION_TYPE_EXTENDED && 
             (t.type & TelePointConstants.TELESTRATION_TYPE_REMOVE) == TelePointConstants.TELESTRATION_TYPE_REMOVE) {
      this.remove(t.pid, t.extendedType, t.coords)
    }
    else if (t.pid != DS_CONSTANTS.UNKNOWN_PARTICIPANT_ID) {
      var set = this.getSet(isTeleVideoWhileInImageShare, t.pid);

      // set the video telestration colour
      if (t.colourArgb != null) {
        set.strokeStyle = argbToRGB(t.colourArgb);
      }

      // pen down?
      if (t.type & TelePointConstants.TELESTRATION_TYPE_PENDOWN) {
        set.processMouseDown(t.extendedType);
        if (t.extendedType == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) {
          set.currItem.fontId = t.text.fontId;
          set.currItem.fontSize = t.text.fontSize;
          set.currItem.text = t.text.text;
        }
      }

      // process any points
      if (t.num > 0 && t.num < TelePointConstants.TELESTRATION_MAX_TELEPOINTS) {
        // for each point in the array, add it to the telestration object              
        for (var i = 0; i < t.num; i++) {
          if (set.processMouseMove(t.extendedType, t.coords[i])) {
              t.type |= TelePointConstants.TELESTRATION_TYPE_PENDOWN;
          }
        }              
      }
      
      // pen up?
      if (t.type & TelePointConstants.TELESTRATION_TYPE_PENUP) {
        set.processMouseUp(t.extendedType);
      }

      // any data to draw?
      if (t.num > 0 && !isTeleVideoWhileInImageShare) {
        // figure out which points to draw
        var first = 0;
        var coords = set.currItem.coords;
        if (coords.length  > t.num) {
            first = coords.length - t.num - 1;
        }

        var pids = [];
        pids.push(set.pid);        

        this.signalEvent({
          type: TelePointConstants.TELESTRATION_EVENT_TYPE_DRAW,
          teleType: t.extendedType,
          pids : pids,
          coords: coords,
          set: set,
          first: first,
          last: coords.length - 1,
          text: (t.extendedType == TelePointConstants.TELESTRATION_ITEM_TYPE_TEXT) ? {fontId : t.text.fontId, fontSize : t.text.fontSize, text : t.text.text } : null,
          telestration: this.telestration
        });
      }
    }
  }
}

TelestrationManager.prototype.addSample = function(_sample, _type) {
  if (_type == DS_CONSTANTS.DS_HDR_TYPE_TELE_JSON.id)
    var t = new TelePointDataV3(_sample.buffer);
  else
      var t = new TelePointData(_sample.buffer, DS_CONSTANTS.DS_HDR_SIZE_BYTES);
    this.add(t);
}

TelestrationManager.prototype.clearSet = function(_pids) {
  var sets = this.telestration.clear(_pids);
  var tm = this;
  sets.forEach(function(set) {
      tm.signalEvent({
        type: TelePointConstants.TELESTRATION_EVENT_TYPE_CLEAR,
        set: set,
        telestration: tm.telestration,
    })
  });
}

TelestrationManager.prototype.remove = function(_pid, _type, _coords) {
  var removeItem = new TelestrationItem(_type);
  removeItem.coords = _coords;

  var removed = this.telestration.remove(_pid, removeItem);
  if (removed != null) {
    var tm = this;
    tm.signalEvent({
      type: TelePointConstants.TELESTRATION_EVENT_TYPE_REMOVE,
      set: removed.set,
      item: removed.item, 
      telestration: tm.telestration,
    })
  }
}

TelestrationManager.prototype.getColour = function(_pid) {
  if (this.colourMap[_pid] == null) {
    this.colourMap[_pid] = RecordedTelestrationColoursDefault[this.nextTelestrationColour++];
  }
  return this.colourMap[_pid];
}

TelestrationManager.prototype.setColour = function(_pid, _colour) {
  this.colourMap[_pid] = _colour;
}

TelestrationManager.prototype.getSet = function(_video, _pid) {
  if (_video) {
    return this.telestrationVideo.getOrAllocateSet(_pid, this.getColour(_pid));
  }
  else {
   return this.telestration.getOrAllocateSet(_pid, this.getColour(_pid)); 
  }
}

TelestrationManager.prototype.signalEvent = function(_event) {    
  if (this.onTelestrationEventCallback != null && _event != null) {
    logger.debug(TELESTRATION_LOG_EN, TELESTRATION_LOG_EVENT_TAG, _event);
    this.onTelestrationEventCallback(_event);
  }
}

TelestrationManager.prototype.setOnTelestrationEventCallback = function(_callback) {
  this.onTelestrationEventCallback = _callback;
}


TelestrationManager.prototype.setWorkspaceTelestrationColour = function(_colour) {
  this.defaultColour = _colour;
}